import { render, staticRenderFns } from "./investment.vue?vue&type=template&id=7ecd874d"
import script from "./investment.vue?vue&type=script&lang=js"
export * from "./investment.vue?vue&type=script&lang=js"
import style0 from "./investment.vue?vue&type=style&index=0&id=7ecd874d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports